import React from 'react';
import HomePage from './components/HomePage/HomePage';
import VereinsCalendar from "./components/CalendarApp/VereinsCalendar/VereinsCalendar";
import { BrowserRouter, Routes, Route, } from "react-router-dom";

const App: React.FC = () => {

  return (
    <BrowserRouter>
      <Routes>
        {/* Other routes of your app */}
        <Route path="/" element={<HomePage />} />

        {/* Vereins calendar mounted under /verein */}
        <Route path="/verein/:verein/*" element={<VereinsCalendar />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;